import { useContext } from 'react';
import { FormInitContext } from '../../context/FormInitContext';

export const useFormInitContext = () => {
  const context = useContext(FormInitContext);

  if (context.isProvided === false) {
    throw new Error('useFormInit must be used within a FormInitProvider');
  }

  return context;
};
